export default class StickyButton
{
    constructor(_buttonSelector)
    {
        this.$ =
        {
            cursor: document.querySelector('.cursor'),
            containers: document.querySelectorAll(_buttonSelector),
            scrollContent: document.querySelector('.scroll-content'),
            hitbox: [],
            button: [],
            filler: [],
        }

        this.int =
        {
            button: [],
            hitbox: [],
        }

        this.mouse =
        {
            x: 0,
            y: 0,
        }

        this.bool =
        {
            cursorInit: false,
            isHover: false,
            mouseleave: false,
            mouseleaveSpecific: [],
        }

        this.offsetY = 0

        this.$.containersPos = []

        this.$.containers.forEach(container => {
            const containerClientRect = container.getBoundingClientRect();
            this.$.containersPos.push({
                x: containerClientRect.left + (containerClientRect.width / 2),
                y: containerClientRect.top + (containerClientRect.height / 2)
            })
        })

        this._initStyle()
        this._listeners()
        this._initScrollContent()
    }

    _initScrollContent()
    {
        this.$.scrollContent = document.querySelector('.scroll-content')
        setTimeout(() => {
            if(!this.$.scrollContent)
            {
                this._initScrollContent()
            }
        }, 100)
    }

    _initStyle()
    {
        for(const [index, container] of this.$.containers.entries())
        {
            const button =
            {
                width: getComputedStyle(this.$.containers[index]).width,
                height: getComputedStyle(this.$.containers[index]).height,
            }

            const stickyButton =
            {
                filler: document.createElement('div'),
                // hitbox: document.createElement('div'),
                button: document.createElement('div'),
            }

            // stickyButton.hitbox.classList.add('stickyButton__hitbox')
            stickyButton.button.classList.add('stickyButton__button')
            stickyButton.filler.classList.add('stickyButton__filler')

            // container.appendChild(stickyButton.hitbox)
            // container.appendChild(stickyButton.button)
            
            if (!container.querySelector('.cta__trigger')) {
                const newElement = document.createElement('div')
                newElement.className = 'cta__trigger'
                container.insertBefore(newElement, container.firstChild);
            }
            
            container.querySelector('.cta__trigger').append(stickyButton.button)

            stickyButton.button.appendChild(stickyButton.filler)

            // Set constructor elements
            // this.$.hitbox.push(stickyButton.hitbox)
            this.$.button.push(stickyButton.button)
            this.$.filler.push(stickyButton.filler)

            stickyButton.button.style.width = `${button.width}`
            stickyButton.button.style.height = `${button.height}`
            if (container.querySelector('.cta__trigger_svg')) {
                container.querySelector('.cta__trigger_svg').setAttribute('width', `${button.width}`)
                container.querySelector('.cta__trigger_svg').setAttribute('height', `${button.height}`)
                container.querySelector('.cta__trigger_svg rect').setAttribute('width', (parseFloat(button.width.replace('px', ''))-1)+'px' )
                container.querySelector('.cta__trigger_svg rect').setAttribute('height', (parseFloat(button.height.replace('px', '')))+'px')
            }

            this.int.button.push({ offsetTop: this.$.button[index].getBoundingClientRect().top, offsetLeft: this.$.button[index].getBoundingClientRect().left })
            // this.int.hitbox.push({ offsetTop: this.$.hitbox[index].getBoundingClientRect().top, offsetLeft: this.$.hitbox[index].getBoundingClientRect().left })
        }

        window.innerWidth < 600 ? this.$.cursor.style.display = 'none' : this.$.cursor.style.display = 'block'
    }

    _listeners()
    {
        for(let i = 0; i < this.$.button.length; i++)
        {
            // this.$.hitbox[i].addEventListener('mouseenter', () => { this._handleHitbox() })

            this.$.containers[i].querySelector('.stickyButton__button').addEventListener('mouseenter', (_event) => { this._handleFiller(_event, i, 'in') })
            this.$.containers[i].querySelector('.stickyButton__button').addEventListener('mouseleave', (_event) => { this._handleFiller(_event, i, 'out') })
            this.$.containers[i].querySelector('.cta__trigger').addEventListener('mousemove', (_event) => { this._handleMove(_event, i) })
            this.$.containers[i].querySelector('.cta__trigger').addEventListener('mouseleave', () => { this._handleMoveOut(i) })
        }



        window.addEventListener('mousemove', (_event) => { this._handleCursor(_event) })
        window.addEventListener('resize', (_event) =>
        {
            this._handleUpdateVariables(_event)
            this._handleCheckCursor()
        })
        window.addEventListener('scroll', (_event) => { this._handleUpdateCursor(_event) })
        // window.addEventListener('mousewheel', (_event) => { this._handleOffsetY(_event) })
        setInterval(() => {
            this._handleOffsetY()
        }, 500);
    }

    _handleOffsetY(_event)
    {
        // this.offsetY = getComputedStyle(this.$.scrollContent).transform.split([','], 6)[5].slice(1, -1)

        this._handleUpdateCursor()
    }

    _handleCheckCursor()
    {
        window.innerWidth < 600 ? this.$.cursor.style.display = 'none' : this.$.cursor.style.display = 'block'
    }

    _handleUpdateVariables()
    {
        for(const [index, button] of this.$.button.entries())
        {
            this.int.button[index].offsetTop = button.getBoundingClientRect().top
            this.int.button[index].offsetLeft = button.getBoundingClientRect().left

            // this.int.hitbox[index].offsetTop = this.$.hitbox[index].getBoundingClientRect().top
            // this.int.hitbox[index].offsetLeft = this.$.hitbox[index].getBoundingClientRect().left
        }
    }

    _handleUpdateCursor()
    {
        for(const [index, button] of this.$.button.entries())
        {
            this.int.button[index].offsetTop = this.$.button[index].getBoundingClientRect().top
            this.int.button[index].offsetLeft = this.$.button[index].getBoundingClientRect().left
        }
    }

    _handleHitbox()
    {
    }

    _handleButton()
    {
    }

    _handleFiller(_event, _index, _direction)
    {
        if (this.$.containers[_index].classList.contains('active')) {
            return false
        }
        const translateX = this.int.button[_index].offsetLeft + (this.$.button[_index].offsetWidth / 2) - this.$.cursor.offsetWidth / 2
        const translateY = this.int.button[_index].offsetTop + (this.$.button[_index].offsetHeight / 2) - this.$.cursor.offsetWidth / 2

        if(_direction == 'in')
        {
            this.bool.isHover = true

            TweenMax.to(this.$.cursor, .3, { x: `${translateX}px`, y: `${translateY}px`, scale: 0 })
            TweenMax.to(this.$.filler[_index], .1, { scale: 1.5 })
        }
        else if(_direction == 'out')
        {
            this.bool.isHover = false
            this.bool.mouseleave = true
            this.bool.mouseleaveSpecific[_index] = true

            TweenMax.to(this.$.filler[_index], .1, { scale: .001 })
        }
    }

    _handleButton(_event)
    {
        const translateX = _event.clientX - this.int.hitbox.offsetLeft - (this.$.hitbox.offsetWidth / 2)
        const translateY = _event.clientY - this.int.hitbox.offsetTop - (this.$.hitbox.offsetHeight / 2)

        if(translateX < 60 && translateX > -60 && translateY < 60 && translateY > -60)
        {
            TweenMax.to(this.$.button, .3, { x: `${translateX}px`, y: `${translateY}px` })
        }
        else
        {
            TweenMax.to(this.$.button, .3, { x: 0, y: 0 })
        }
    }

    _handleMove(_event, i)
    {
        if (this.$.containers[i].classList.contains('active')) {
            return false
        }
        
        let x = _event.clientX
        let y = 0
        if (document.querySelector('.scroll-content')) {
            y = _event.clientY - this.getComputedTranslateY(document.querySelector('.scroll-content'))
        } else {
            y = _event.clientY
        }

        TweenMax.to(this.$.containers[i], 0.4, {
            x: (x - this.$.containersPos[i].x) * 0.4,
            y: (y - this.$.containersPos[i].y) * 0.4,
            ease: Power2.easeOut
        })
        // const translateX = _event.pageX - this.$.containersPos[i].x
        // const translateY = _event.pageY - this.getComputedTranslateY(document.querySelector('.scroll-content')) - this.$.containersPos[i].y
        // TweenMax.set(this.$.containers[i], { x: `${translateX * 0.4}px`, y: `${translateY * 0.4}px` })
    }

    _handleMoveOut(i)
    {
        if (this.$.containers[i].classList.contains('active')) {
            return false
        }
        
        TweenMax.to(this.$.containers[i], 0.7, { x: 0, y: 0, ease: Elastic.easeOut.config(1.2, 0.4) })
    }

    _handleCursor(_event)
    {
        this.mouse.x = _event.clientX - (this.$.cursor.offsetWidth / 2)
        this.mouse.y = _event.clientY - (this.$.cursor.offsetHeight / 2)

        if(!this.bool.cursorInit && !this.bool.isHover)
        {
            this.bool.cursorInit = true

            TweenMax.to(this.$.cursor, 0, { x: this.mouse.x, y: this.mouse.y })
        }

        if(!this.bool.isHover && !this.bool.mouseleave) TweenMax.to(this.$.cursor, .1, { x: this.mouse.x, y: this.mouse.y })

        for(const [index] of this.$.button.entries())
        {

            if(this.bool.mouseleave)
            {
                TweenMax.to(this.$.cursor, .3, { x: this.mouse.x, y: this.mouse.y, scale: 1 })
                if(this.bool.mouseleaveSpecific[index]) TweenMax.to(this.$.filler[index], .1, { scale: .001 })
                this.bool.mouseleave = false
                this.bool.mouseleaveSpecific[index] = false
            }
        }
    }

    getComputedTranslateY(obj)
    {
        if(!window.getComputedStyle) return;
        var style = getComputedStyle(obj),
            transform = style.transform || style.webkitTransform || style.mozTransform;
        var mat = transform.match(/^matrix3d\((.+)\)$/);
        if(mat) return parseFloat(mat[1].split(', ')[13]);
        mat = transform.match(/^matrix\((.+)\)$/);
        return mat ? parseFloat(mat[1].split(', ')[5]) : 0;
    }

}
